import type { ClientLinkStatus } from "@enrein/shared-contracts/client-link";

const INTAKE_PHASE_STATUSES = new Set<ClientLinkStatus>([
  "INTAKE_OPEN",
  "INTAKE_IN_PROGRESS",
  "INTAKE_SUBMITTED",
]);

export function isIntakePhase(status: string): boolean {
  return INTAKE_PHASE_STATUSES.has(status as ClientLinkStatus);
}
